(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo/assets/javascripts/views/start.js') >= 0) return;  svs.modules.push('/modules/bingo/assets/javascripts/views/start.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.bingo.views.Start = Marionette.View.extend({
    template: function(data) {
      return svs.bingo.templates.start(data);
    },

    behaviors: [
      {
        behaviorClass: svs.bingo.behaviors.UpdateCollection,
        resetView: 'resetView'
      }
    ],

    regions: {
      startComponentRegion: '#startcomponentregion'
    },

    initialize: function(options) {
      this.startPageConfig = options.startPageConfig;
      this.startPageConfig.promoRegion.defaultPromo.items.on(
        'navigate',
        this.navigate,
        this
      );
    },

    onAttach: function() {
      this.triggerMethod('resetView');
    },

    onResetView: function() {
      this.showChildView(
        'startComponentRegion',
        new svs.app.productStartPage.ProductStartPage(this.startPageConfig)
      );
      this.triggerMethod(
        'setUpdateTimeout',
        this.startPageConfig.promoRegion.defaultPromo.items
      );
      this.triggerMethod(
        'setClosingInterval',
        this.startPageConfig.promoRegion.defaultPromo.items.models
      );
    },

    navigate: function(id, disabled, name) {
      if (!disabled) {
        if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
          svs.bingo.router.navigate('spela/' + id, { trigger: true });
        } else {
          svs.components.customer_login.login();
        }
      } else {
        svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
          branding: svs.ui.dialog.branding.SPORT,
          title: name + ' har tyvärr stängt!',
          icon: 'bingo',
          area: svs.ui.dialog.area.POPUP,
          type: svs.ui.dialog.type.CONFIRM,
          message: [
            {
              type: svs.ui.dialog.message.TEXT,
              text: 'Pröva ett annat Bingospel.'
            }
          ],
          actions: [
            {
              title: 'Ok'
            }
          ]
        }));
      }
    },

    onDestroy: function() {
      this.startPageConfig.promoRegion.defaultPromo.items.off(
        'navigate',
        this.navigate
      );
    }
  });
})(Backbone, _, svs);


 })(window);